import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=fb50a404&scoped=true&"
import script from "./AboutUS.vue?vue&type=script&lang=js&"
export * from "./AboutUS.vue?vue&type=script&lang=js&"
import style0 from "./AboutUS.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AboutUS.vue?vue&type=style&index=1&id=fb50a404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb50a404",
  null
  
)

export default component.exports